module.exports = __webpack_public_path__ + "img/10x_sm.bed22152.jpg";